export { TypingIndicator, type TypingIndicatorProps } from "./TypingIndicator"
